import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { GET_COMPLETED_SLIDES_BEGIN, logError, getCompletedSlidesSuccess, setCourseStatus } from "../actions";
export default function getCompletedSlides(action$, state$) {
    return action$.pipe(ofType(GET_COMPLETED_SLIDES_BEGIN), switchMap(function(action) {
        return !state$.value.api ? [
            logError({
                error: new Error("No LMS API found"),
                key: "no_api"
            })
        ] : [
            getCompletedSlidesSuccess({
                slides: state$.value.api.getCompletedSlides().filter(function(s) {
                    var node = state$.value.nodes.find(function(n) {
                        return n.id === s[0];
                    });
                    return /completed|passed/.test(s[1]) || node && /failed/.test(s[1]) && !node.success_required;
                }).map(function(s) {
                    return s[0];
                })
            }),
            setCourseStatus()
        ];
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "get_completed_slides"
        }));
    }));
}
